import { Component } from 'react';

import Field from './Field';
import Select from './Select';

class SelectField extends Component {
    state = {
        value: this.props.value
    };

    handleChange = (option, form, field) => {
        this.setState({ value: null });

        if (this.props.onChange) {
            this.props.onChange(option, form, field);
        }

        if (!option) {
            form.setFieldValue(field.name, null);
            return;
        }

        form.setFieldValue(field.name, option.value);
    };

    handleBlur = (form, field) => {
        if (this.props.onBlur) {
            this.props.onBlur(form, field);
        }
        form.setFieldTouched(field.name);
    };

    renderInput = props => {
        const { value } = this.state;
        const { countryID, form, field } = props;
        const attrs = {
            countryID
        };

        return (
            <Select
                {...attrs}
                {...this.props}
                isDisabled={this.props.readOnly}
                value={value ? value : field.value}
                onChange={option => this.handleChange(option, form, field)}
                onBlur={() => this.handleBlur(form, field)}
            />
        );
    };

    render() {
        return <Field {...this.props} render={props => this.renderInput(props)} />;
    }
}

export default SelectField;
